/*--------------------------------------------------------------------------*
 * TOPページ
 *--------------------------------------------------------------------------*/
module Module_Index {
	export class Model_Index {
		// 検索パネルのエリア位置調整
		ajustIndexAreaList(): void {
			const parents: JQuery = $(".c-list09"),
				parentColumnLimit: number = 2,
				childColumnLimit: number = 4,
				diffArr: number[] = [0, 0];

			for(let i=0; i<parents.length; i=i+parentColumnLimit) {
				let groupOfParent: HTMLElement[] = [],
					maxDiff: number = 0,
					rowLengthArr: number[] = [];
				for(let j=0; j<parentColumnLimit; j++) {
					const _self: JQuery = parents.eq(i+j),
						children: JQuery = _self.find(".c-list10__item"),
						rowLength: number = Math.ceil(children.length / childColumnLimit);
					groupOfParent.push(_self[0]);
					rowLengthArr.push(rowLength);
				}

				$.each(diffArr, function(j: number, val: number) {
					if(val > maxDiff) {
						maxDiff = val;
					}
				});

				$.each(groupOfParent, function(j: number) {
					const rowDiff: number = diffArr[j],
						thisDiff: number = maxDiff - rowDiff,
						marginTop: number = -(16 * thisDiff);
					if(thisDiff !== 0) {
						parents.eq(i+j).css({marginTop: marginTop});
					}
					diffArr[j] += rowLengthArr[j];
				});
			}
		}

		// 新着求人の整形
		newJobConfig(): void {
			const elm: JQuery = $('[data-line_limit]');

			const matchHeight = function(): void {
				let maxHeight: number = 0;
				elm.each(function(): void {
					const height: number = Number($(this).height());
					if(height > maxHeight) {
						maxHeight = height;
					}
				});
				elm.height(maxHeight);
			}

			const init = function(): void {
				matchHeight();
			}();
		}
	}
}
